export enum GridColumnType {
  Select,
  Text,
  DateTime,
  Currency,
  HTML,
  Toggle,
  Actions
}
